import script from "./AddSignalToFavourites.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSignalToFavourites.vue?vue&type=script&setup=true&lang=js"

import "./AddSignalToFavourites.vue?vue&type=style&index=0&id=dae47b0a&lang=scss"

const __exports__ = script;

export default __exports__